import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";
import {
  BatchItem,
  BatchesResponse,
  BatchesParams,
  CreateBatchItem,
  UpdateBatchItem,
  GetBatchByIdParams,
  CreateFortnoxInvoiceResponse,
} from "./models";

export const batchesApi = createApi({
  baseQuery,
  reducerPath: "batchesApi",
  tagTypes: ["Batches"],
  endpoints: (builder) => ({
    getAllBatches: builder.query<BatchesResponse, BatchesParams>({
      query: (params) => ({
        url: "/api/v1/batches/",
        method: "GET",
        params,
      }),
      providesTags: ["Batches"],
    }),

    getBatchById: builder.query<BatchItem, GetBatchByIdParams>({
      query: ({ id, expand }) => ({
        url: `/api/v1/batches/${id}/`,
        method: "GET",
        params: expand ? { expand } : undefined,
      }),
      providesTags: (_result, _error, { id }) => [{ type: "Batches", id }],
    }),

    createBatch: builder.mutation<BatchItem, CreateBatchItem>({
      query: (body) => ({
        url: "/api/v1/batches/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Batches"],
    }),

    updateBatch: builder.mutation<BatchItem, UpdateBatchItem>({
      query: ({ id, ...body }) => ({
        url: `/api/v1/batches/${id}/`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        "Batches",
        { type: "Batches", id },
      ],
    }),

    deleteBatch: builder.mutation<void, number>({
      query: (id) => ({
        url: `/api/v1/batches/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["Batches"],
    }),

    createFortnoxInvoice: builder.mutation<
      CreateFortnoxInvoiceResponse,
      number
    >({
      query: (id) => ({
        url: `/api/v1/batches/${id}/create_fortnox_invoice/`,
        method: "POST",
      }),
      invalidatesTags: (_result, _error, id) => [
        "Batches",
        { type: "Batches", id },
      ],
    }),
  }),
});

export const {
  useGetAllBatchesQuery,
  useGetBatchByIdQuery,
  useCreateBatchMutation,
  useUpdateBatchMutation,
  useDeleteBatchMutation,
  useCreateFortnoxInvoiceMutation,
} = batchesApi;
